<template>
<div class="chapter">
<div class="inner_page">
<p class="fn1"><span>I was born on the prairie where the wind blew free</span></p>
<p class="fn2"><span>and there was nothing to break the light of the sun.</span></p>
<p class="fn2"><span>—<span class="smallcaps">GERONIMO</span>, <i>from his autobiography</i></span></p>
<p class="fn1"><span>This is a Godforsaken country and a</span></p>
<p class="fn2"><span>Godforsaken people living in it!</span></p>
<p class="fn2"><span>— <span class="smallcaps">CAPT. HENRY LAWTON</span>,</span></p>
<p class="fn2"><span><i>Indian fighter, on entering Apache Territory</i>,</span></p>
<p class="fn2"><span><i>from</i> The Journal of Leonard Wood</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter02.vue?40bd5df4